export class SchoolEducationalDetails { 
    schoolEducationalDetailId?: number; 
    schoolId?: number; 
    academicProgramId: number;
    educationalProgramId?: number;
}